import { render } from "./ConfirmCode.vue?vue&type=template&id=4a9c162a"
import script from "./ConfirmCode.vue?vue&type=script&lang=js"
export * from "./ConfirmCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__